"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hoverCardContentPropDefs = void 0;
const index_js_1 = require("../helpers/index.js");
const contentSizes = ['1', '2', '3'];
const hoverCardContentPropDefs = {
    asChild: index_js_1.asChildProp,
    size: {
        type: 'enum',
        className: 'rt-r-size',
        values: contentSizes,
        default: '2',
        responsive: true,
    },
};
exports.hoverCardContentPropDefs = hoverCardContentPropDefs;
//# sourceMappingURL=hover-card.props.js.map